import Chart from "react-apexcharts";

const DEFAULT_COLORS = ["#2152FF", "#22c55e", "#f59e0b", "#ef4444", "#8b5cf6"];

const DonutChart = ({ data = [], height = 280, colors = DEFAULT_COLORS }) => {
  if (!data.length) return null;
  const labels = data.map((d) => d.label);
  const series = data.map((d) => Number(d.value) || 0);
  const total = series.reduce((a, b) => a + b, 0);
  const options = {
    chart: { type: "donut", fontFamily: "Cairo, DM Sans, sans-serif" },
    labels,
    colors,
    legend: { position: "bottom", fontSize: "12px" },
    dataLabels: { enabled: false },
    plotOptions: {
      pie: {
        donut: {
          size: "65%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "الإجمالي",
              color: "#252f40",
              formatter: () => `${total}`,
            },
            value: { color: "#252f40", fontSize: "20px", fontWeight: 700 },
          },
        },
      },
    },
    stroke: { width: 0 },
  };
  return <Chart options={options} series={series} type="donut" height={height} />;
};

export default DonutChart;
